import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const PageHeader = styled.h1`
    ${Fonts.Heading.H300};
    flex-basis: 20%;
    flex-grow: 1;

    margin: 0;

    line-height: 32px;
    color: ${Colors.Black.V200};
    white-space: nowrap;
`;
